import React, { useEffect, useState } from 'react';

import z, { ZodTypeAny } from 'zod';

export const useLocalStorageState = <T extends ZodTypeAny, V = z.infer<T>>(
  name: string,
  type: T,
  defaultValue: V,
): [V, React.Dispatch<React.SetStateAction<V>>] => {
  const [v, setV] = useState(() => {
    try {
      const rawV = JSON.parse(localStorage.getItem(name) ?? JSON.stringify(defaultValue));
      const result = type.safeParse(rawV);

      if (result.success) {
        return result.data;
      } else {
        return defaultValue;
      }
    } catch (e) {
      if (e instanceof SyntaxError) {
        return defaultValue;
      }
      throw e;
    }
  });

  useEffect(() => {
    localStorage.setItem(name, JSON.stringify(v));
  }, [v]);

  return [v, setV];
};
